module.exports = __webpack_public_path__ + "static/media/pic4.314d5729.png";